import { useEffect, useState } from "react";
import { clientConfig, SetS3Config } from "../awsClientConfig";
import { userProfileData } from "../Common/profileInfo";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowDown, faPrint } from "@fortawesome/free-solid-svg-icons";
import { Storage } from "aws-amplify";
import "../styles/ots-res-service-agreement.css";
import { CompleteProfileForm } from "../queries/CompleteProfileForm";
import { GetLatestFormsByProfile } from "../queries/GetLatestFormsByProfile";

const OtsResServiceAgreement = () => {

  type Form = {
    __typename: "Form",
    Active: boolean,
    CompletedAt?: string | null,
    CreatedAt: string,
    Id: string,
    Name: string,
    S3Bucket: string,
    S3Key: string,
    S3VersionId?: string | null,
    TemplateId: string,
    UpdatedAt: string,
  };

  const [s3Bucket, setS3Bucket] = useState("");
  const [s3key, setS3Key] = useState("");
  const [formId, setFormId] = useState("");
  const client = new clientConfig();

  //////////////////////////////////////////////////
  // Complete Profile Form
  //////////////////////////////////////////////////
  const completeProfileForm = async () => {
    const profileId = await userProfileData();
    SetS3Config(`signatures-${process.env.REACT_APP_MODE}-optima-financial-group`, "public");
    client
      .mutate({
        mutation: CompleteProfileForm,
        variables: {
          ProfileId: profileId,
          FormId: formId
        }
      })
      .then((res: any) => {
        if (res.data.CompleteProfileForm) {
          setS3Bucket(res.data.CompleteProfileForm?.S3Bucket);
          setS3Key(res.data.CompleteProfileForm?.S3Key);
          getDocument();
        }
      })
      .catch((error: any) => {
        console.log("error" + error);
      });
  };

  //////////////////////////////////////////////////
  // Get Document
  //////////////////////////////////////////////////
  const [agreement, setAgreement] = useState("");
  const isPDF = s3key?.includes(".pdf");
  let contentType = isPDF ? "application/pdf" : "text/html";
  const getDocument = async () => {
    try {
      SetS3Config(s3Bucket, "public");
      const doc = await Storage.get(s3key, {
        customPrefix: { public: "" },
        contentType: contentType,
      });
      if (isPDF) {
        setAgreement(doc);
      } else {
        const html = await fetch(doc).then((res) => res.text());
        setAgreement(html);
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  //////////////////////////////////////////////////
  // Download
  //////////////////////////////////////////////////
  const download = async () => {
    try {
      SetS3Config(s3Bucket, "public");
      const Agreement: any = await Storage.get(s3key, {
        customPrefix: { public: "" },
        download: true,
        contentType: contentType,
      });
      downloadBlob(Agreement.Body, "Service Agreement");
    } catch (error) {
      console.log("error", error);
    }
  };
  function downloadBlob(blob: any, filename: any) {
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename || "download";
    const clickHandler = () => {
      setTimeout(() => {
        URL.revokeObjectURL(url);
        a.removeEventListener("click", clickHandler);
      }, 150);
    };
    a.addEventListener("click", clickHandler, false);
    a.click();
    return a;
  }

  //////////////////////////////////////////////////
  // Print
  //////////////////////////////////////////////////
  function printPdf() {
    fetch(agreement)
      .then(async (response) => {
        return await response.arrayBuffer();
      })
      .then((result) => {
        const newBlob = new Blob([result], { type: "application/pdf" });
        const fileLink = window.URL.createObjectURL(newBlob);
        const iframe = document.createElement("iframe");
        iframe.src = fileLink;
        iframe.id = "print_pdf";
        iframe.name = "print_pdf";
        iframe.style.display = "none";
        document.body.appendChild(iframe);
        const windowVal: any = window;
        windowVal.frames["print_pdf"].focus();
        windowVal.frames["print_pdf"].print();
      })
      .catch((error) => console.log("error", error));
  }
  function printImage() {
    if (isPDF) {
      printPdf();
    } else {
      const tempHtml =
        "<html><head><scri" +
        "pt>function step1(){\n" +
        "setTimeout('step2()', 10);}\n" +
        "function step2(){window.print();window.close()}\n" +
        "</scri" +
        "pt></head><body onload='step1()'>\n" +
        "<div dangerouslySetInnerHTML={{ __html:" +
        agreement +
        " }} />" +
        "</body></html>";
      var Pagelink = "about:blank";
      var pwa: any = window.open(Pagelink, "_new");
      pwa.document.open();
      pwa.document.write(tempHtml);
      pwa.document.close();
    }
  }

  //////////////////////////////////////////////////
  // Page Load
  //////////////////////////////////////////////////
  const getLatestFormsByProfile = async () => {
    const profileId = await userProfileData();
    await client
      .query({
        query: GetLatestFormsByProfile,
        variables: {
          ProfileId: profileId,
        }
      })
      .then((res: any) => {
        var forms: Form[] = res.data.GetLatestFormsByProfile;
        forms.forEach((form) => {
          if (form.Name == 'OtsResServiceAgreement') {
            setS3Bucket(form.S3Bucket);
            setS3Key(form.S3Key);
            setFormId(form.Id);
          }
        });
        getDocument();
      });
  };
  useEffect(() => {
    getLatestFormsByProfile();
    //completeProfileForm();
  }, []);
  //////////////////////////////////////////////////

  return (
    <div className="otsClientServiceAgreement">
      <div className="row">
        <div className="col-md-9">
          <h1 className="pageTitle">
            Optima Tax Shield Client Service Agreement
          </h1>
        </div>
        <div className="col-md-3">
          <div className="text-end" style={{ marginRight: "20px" }}>
            <span className="letsdolater" onClick={printImage}>
              <FontAwesomeIcon className="" icon={faPrint} /> Print
            </span>
            <span className="letsdolater" style={{ marginLeft: "10px" }} onClick={download}>
              <FontAwesomeIcon className="" icon={faArrowDown} /> Download
            </span>
          </div>
        </div>
      </div>
      <div className="mt-2 mb-2" style={{ height: "100vh", overflow: "auto", padding: "20px" }}>
        {isPDF ? (
          <iframe src={agreement} title="OTS Client Service Agreement" style={{ width: "100%", height: "95%", objectFit: "cover" }} />
        ) : (
          <div dangerouslySetInnerHTML={{ __html: agreement }} />
        )}
      </div>
    </div>
  );
};

export default OtsResServiceAgreement;